<div class="relative w-full h-full">
  @if (render.isLoading()) {
    <div class="absolute inset-0 flex items-center justify-center bg-white z-10">
      <app-loading-indicator>Loading file...</app-loading-indicator>
    </div>
  } @else if (render.error()) {
    <app-preview-error [error]="render.error()"/>
  }
  <div
    #container
    class="w-full h-full overflow-auto bg-gray-100 p-4"
    [class.invisible]="render.isLoading() || !!render.error()"
  ></div>
</div>
